import ClassNames from 'classnames'
import React from 'react'
import {
  Grid,
  Image,
  Text
} from './../../../components'
import {
  ICONS,
  VARIABLES
} from './../../../themes'
import {
  NotificationBase
} from './../../base'
import { NotificationWrapper } from './styled'

export class Notification extends React.PureComponent {
  render() {
    const {
      className,
      children,
      ui,
      message
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
    )

    return (
      <React.Fragment>
        {(() => {
          switch (ui) {
            case 'success':
              return (
                <NotificationWrapper
                  {...this.props}
                  className={ClassNames(
                    className,
                    'is-success',
                  )}
                  paddingVertical='13'
                  // spacingBottom='13'
                  // spacingHorizontal='30'
                  bgColor={VARIABLES.COLORS.OVERLAY_GREEN_1}
                  borderWidth='1'
                  borderStyle='solid'
                  borderColor={VARIABLES.COLORS.GREEN_3}
                  borderRadius='3'
                >
                  <Grid
                    gutter='15'
                    justify='center'
                  >
                    <Grid.Column flex='none'>
                      <Image
                        widthRatio='18'
                        widthRatioUnit='px'
                        heightRatio='18'
                        heightRatioUnit='px'
                        src={ICONS['ic-notification-success.svg']}
                      />
                    </Grid.Column>
                    <Grid.Column flex='1'>
                      <Text
                        bold12
                        color={VARIABLES.COLORS.GREEN_5}
                      >
                        {message}
                      </Text>
                    </Grid.Column>
                  </Grid>
                </NotificationWrapper>
              )
            case 'error':
              return (
                <NotificationWrapper
                  {...this.props}
                  className={ClassNames(
                    className,
                    'is-error',
                  )}
                  paddingVertical='13'
                  // spacingBottom='13'
                  // spacingHorizontal='30'
                  bgColor={VARIABLES.COLORS.OVERLAY_RED_1}
                  borderWidth='1'
                  borderStyle='solid'
                  borderColor={VARIABLES.COLORS.RED_4}
                  borderRadius='3'
                >
                  <Grid
                    gutter='15'
                    justify='center'
                  >
                    <Grid.Column flex='none'>
                      <Image
                        widthRatio='18'
                        widthRatioUnit='px'
                        heightRatio='18'
                        heightRatioUnit='px'
                        src={ICONS['ic-notification-error.svg']}
                      />
                    </Grid.Column>
                    <Grid.Column flex='1'>
                      <Text
                        bold12
                        color={VARIABLES.COLORS.RED_4}
                      >
                        {message}
                      </Text>
                    </Grid.Column>
                  </Grid>
                </NotificationWrapper>
              )
            case 'info':
              return (
                <NotificationWrapper
                  {...this.props}
                  className={ClassNames(
                    className,
                    'is-info',
                  )}
                  paddingVertical='13'
                  // spacingBottom='13'
                  // spacingHorizontal='30'
                  bgColor={VARIABLES.COLORS.OVERLAY_BLUE_3}
                  borderWidth='1'
                  borderStyle='solid'
                  borderColor={VARIABLES.COLORS.BLUE_21}
                  borderRadius='3'
                >
                  <Grid
                    gutter='15'
                    justify='center'
                  >
                    <Grid.Column flex='none'>
                      <Image
                        widthRatio='18'
                        widthRatioUnit='px'
                        heightRatio='18'
                        heightRatioUnit='px'
                        src={ICONS['ic-notification-info.svg']}
                      />
                    </Grid.Column>
                    <Grid.Column flex='1'>
                      <Text
                        bold12
                        color={VARIABLES.COLORS.BLUE_21}
                      >
                        {message}
                      </Text>
                    </Grid.Column>
                  </Grid>
                </NotificationWrapper>
              )
            default:
              return (
                <NotificationWrapper
                  {...this.props}
                  className={classes}
                >
                  {children}
                </NotificationWrapper>
              )
          }
        })()}
      </React.Fragment>
    )
  }

  static defaultProps = {

  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
